import { TranslationKeys } from './sections/translationKeys';
export const REGULAR_STATE = {
    id: 'regular',
    label: TranslationKeys.states.regularLabel,
    default: true,
};
export const HOVER_STATE = {
    id: 'hover',
    label: TranslationKeys.states.native.hoverLabel,
};
export const DISABLED_STATE = {
    id: 'disabled',
    label: TranslationKeys.states.native.disabledLabel,
};
export const SELECTED_STATE = {
    id: 'selected',
    label: TranslationKeys.states.native.focusLabel,
};
export const ExtensionTypes = {
    ComponentData: 'ComponentData',
    ComponentParts: 'ComponentParts',
    ComponentStates: 'ComponentStates',
    SiteData: 'SiteData',
    WixBI: 'WixBI',
};
export const SectionTypes = {
    TextDesign: 'TextDesign',
    BackgroundDesign: 'BackgroundDesign',
    BorderDesign: 'BorderDesign',
    CornerDesign: 'CornerDesign',
    ShadowDesign: 'ShadowDesign',
    PaddingDesign: 'PaddingDesign',
    IconDesign: 'IconDesign',
    PartPicker: 'PartPicker',
    StatePicker: 'StatePicker',
    Size: 'Size',
};
export const ComponentStates = {
    Regular: REGULAR_STATE,
    Hover: HOVER_STATE,
    Disabled: DISABLED_STATE,
    Selected: SELECTED_STATE,
};
//# sourceMappingURL=constants.js.map